


















































































































































import { Component, Vue } from 'vue-property-decorator';
import { trainServer, dictServe, institutionServer, companyServer } from '@/api/installServer';
import { arrayToTree } from '@/util/arrayToTree';
import publishObjectPath from '@/util/configRegistry';
import { TableStripe } from '@/mixins/tableStripe';
import ChoosePeople from '@/views/licenseManagement/choosePeople.vue';
@Component({
  components: { ChoosePeople },
  mixins: [TableStripe],
})
export default class AddDialog extends Vue {
  private visible = false;
  private title = '';
  private formData: any = {
    organizerType: 'dept',
    classHours: '',
    organizerName: '',
    remark: '',
    trainAddress: '',
    trainCategory: '',
    trainContent: '',
    trainExpenses: '',
    trainMethod: '',
    trainName: '',
    trainTime: '',
    trainer: '',
    companyId: '',
    companyName: '',
    trainerPhone: '',
    trainApplyId: '',
    picture: '',
    enclosure: '',
  };
  private formDataRule: any = {
    trainName: [{ required: true, message: '请输入培训名称', trigger: 'blur' }],
    trainTime: [{ required: true, message: '请选择培训时间', trigger: 'change' }],
    trainer: [{ required: true, message: '请输入培训师', trigger: 'blur' }],
    trainerPhone: [{ required: true, message: '请输入培训人电话', trigger: 'blur' }],
    trainAddress: [{ required: true, message: '请输入培训地点', trigger: 'blur' }],
    organizerName: [{ required: true, message: '请输入主办单位', trigger: 'blur' }],
    companyId: [{ required: true, message: '请选择被培训单位', trigger: 'blur' }],
    trainContent: [{ required: true, message: '请输入培训内容', trigger: 'blur' }],
  };

  private enterpriseData: any = [];

  private date: any = '';
  private canEdit = false;

  private type = ''; // 参训人员 add添加、edit编辑
  private id = ''; // 存储参训人员 一行的id

  private typeList: any = [];
  private methodList: any = [];
  private trainApplyList: any = [];

  picList: any = [];
  fileList: any = [];
  headers: any = {};
  actionUrl: any = ''; // 图片上传
  uploadUrl: any = ''; // 图片上传
  private serverUrl = publishObjectPath.imgPathWater;
  mounted() {
    this.uploadUrl = publishObjectPath.serverUrl + '/api/sysManage/sysFile';
    this.actionUrl = publishObjectPath.serverUrl + '/api/sysManage/sysFile/annex';
    this.headers.Authorization = localStorage.getItem('token');
  }
  getTypeList(name: any) {
    dictServe.getDetailsMapByName(name).then((res: any) => {
      if (res.code === '200') {
        const helpArr: any = [];
        for (const key in res.data) {
          helpArr.push({
            value: key,
            label: res.data[key],
          });
        }
        if (name === 'train_category') {
          this.typeList = helpArr;
        } else if (name === 'train_method') {
          this.methodList = helpArr;
        }
      } else {
        this.$message.warning('获取数据失败！');
      }
    });
  }
  getTrainApplyList() {
    trainServer.trainRequestAllList({}).then((res: any) => {
      if (res.code === '200') {
        this.trainApplyList = res.data;
      } else {
        this.$message.warning('获取数据失败！');
      }
    });
  }

  private handleSuccess(response: any, file: any, fileList: any) {
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response && item.response.data) {
        arr.push(item.response.data[0].id);
      } else {
        arr.push(item.id);
      }
    });
    this.formData.picture = arr.toString();
  }

  private handleRemove(file: any, fileList: any) {
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response && item.response.data) {
        arr.push(item.response.data[0].id);
      } else {
        arr.push(item.id);
      }
    });
    this.formData.picture = arr.toString();
  }
  private handleSuccessFile(response: any, file: any, fileList: any) {
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response && item.response.data) {
        arr.push(item.response.data[0].id);
      } else {
        arr.push(item.id);
      }
    });
    this.formData.enclosure = arr.toString();
  }
  private handleRemoveFile(file: any, fileList: any) {
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response && item.response.data) {
        arr.push(item.response.data[0].id);
      } else {
        arr.push(item.id);
      }
    });
    this.formData.enclosure = arr.toString();
  }
  private handlePreview(file: any) {
    if (this.title === '添加') return;
    const urlPath: any = this.serverUrl + file.path;
    this.getBlob(urlPath).then((blob: any) => {
      this.saveAs(blob, file.name);
    });
  }
  getBlob = (url: any) => {
    return new Promise((resolve: any) => {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.responseType = 'blob';
      xhr.onload = () => {
        if (xhr.status == 200) {
          resolve(xhr.response);
        }
      };
      xhr.send();
    });
  };
  saveAs = (blob: any, name: any) => {
    const url = window.URL.createObjectURL(blob);
    const aLink = document.createElement('a');
    aLink.style.display = 'none';
    aLink.href = url;
    aLink.setAttribute('download', name);
    document.body.appendChild(aLink);
    aLink.click();
    document.body.removeChild(aLink); // 下载完成移除元素
    window.URL.revokeObjectURL(url); // 释放掉blob对象
  };

  showDialog(data: any) {
    this.getTypeList('train_category');
    this.getTypeList('train_method');
    this.getTrainApplyList();
    this.getEnterpriseDataList();
    switch (data.type) {
      case 'add':
        this.title = '添加';
        this.canEdit = false;
        break;
      case 'edit':
        this.title = '编辑';
        this.getData(data.data);
        this.canEdit = false;
        break;
      case 'detail':
        this.title = '详情';
        this.canEdit = true;
        this.getData(data.data);
        break;
    }
    this.visible = true;
  }
  /**
   * 【接口】获取企业列表
   */
  private getEnterpriseDataList() {
    companyServer.getCompanySelectList({}).then((res: any) => {
      this.enterpriseData = res.data;
    });
  }
  companyChange(e: any) {
    if (e) {
      this.formData.companyName = this.enterpriseData.find((item: any) => item.id === e).companyName;
    }
  }

  hideDialog() {
    this.visible = false;
    this.formData = {};
    this.picList = [];
    this.fileList = [];
    this.date = '';
    (this.$refs.form as any).resetFields(); // 重置表单内容
    this.$emit('getTableData');
  }

  private getData(id: any) {
    this.picList = [];
    trainServer.infoTrainRecordData(id).then((res: any) => {
      if (res.code === '200') {
        this.formData = res.data;
        res.data.pictures.forEach((item: any) => {
          this.picList.push({
            url: this.serverUrl + item.path,
            id: item.id,
          });
        });
        this.fileList = res.data.enclosures;
      }
    });
  }

  submitForm() {
    //表单验证
    const formComponent: any = this.$refs['form'];
    formComponent.validate((valid: any) => {
      if (!valid) return;
      if (this.title === '添加') {
        this.addFunction();
      } else {
        this.editFunction();
      }
    });
  }

  /* 新增数据 */
  addFunction() {
    trainServer
      .addTrainRecordData({
        ...this.formData,
        classHours: this.formData.classHours ? Number(this.formData.classHours) : 0,
        trainExpenses: this.formData.trainExpenses ? Number(this.formData.trainExpenses) : 0,
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('成功新增了一条数据！');
          this.hideDialog();
        } else {
          this.$message.success(res.msg);
        }
      });
  }
  /* 编辑数据 */
  editFunction() {
    trainServer
      .editTrainRecordData(this.formData.id, {
        organizerType: this.formData.organizerType,
        organizerName: this.formData.organizerName,
        remark: this.formData.remark,
        trainAddress: this.formData.trainAddress,
        trainCategory: this.formData.trainCategory,
        trainContent: this.formData.trainContent,
        trainMethod: this.formData.trainMethod,
        trainName: this.formData.trainName,
        trainTime: this.formData.trainTime,
        trainer: this.formData.trainer,
        trainApplyId: this.formData.trainApplyId,
        picture: this.formData.picture,
        enclosure: this.formData.enclosure,
        classHours: this.formData.classHours ? Number(this.formData.classHours) : 0,
        trainExpenses: this.formData.trainExpenses ? Number(this.formData.trainExpenses) : 0,
        companyId: this.formData.companyId,
        companyName: this.formData.companyName,
        trainerPhone: this.formData.trainerPhone,
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('成功编辑了一条数据！');
          this.hideDialog();
        } else {
          this.$message.success(res.msg);
        }
      });
  }
  /**
   * 添加人员
   * */
  checkStaffList() {
    const shuttleBox = 'ChoosePeople';
    const shuttleBoxComponent = this.$refs[shuttleBox];
    (shuttleBoxComponent as any).showDialog([]);
    this.type = 'add';
  }
  /**
   * 获取已选人员
   * */
  checkNodeData(data: any) {
    if (data && data[0]) {
      const obj: any = {
        trainId: this.formData.id,
        traineeId: data[0].id,
        traineeName: data[0].name,
      };
      if (this.type === 'add') {
        trainServer.addTrainTraineeData(obj).then((res: any) => {
          if (res.code === '200') {
            this.$message.success('添加成功');
            trainServer.infoTrainRecordData(this.formData.id).then((res: any) => {
              if (res.code === '200') {
                this.formData.trainees = res.data.trainees;
              }
            });
          }
        });
      }
    }
  }
  delStaff(data: any) {
    this.$confirm('此操作将永久删除当前数据, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        trainServer.delTrainTraineeData(data.id).then((res: any) => {
          if (res.code === '200') {
            this.$message.success('删除成功！');
            trainServer.infoTrainRecordData(this.formData.id).then((res: any) => {
              if (res.code === '200') {
                this.formData.trainees = res.data.trainees;
              }
            });
          } else {
            this.$message.warning('网络错误，请稍后再试！');
          }
        });
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        });
      });
  }
}
